<script>
  import "./app.css";
  import DesignEditor from "./presentation/designs/DesignEditor.svelte";

  let x = 1;

</script>

<main>
  <DesignEditor />
</main>

<style>

</style>